"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSeriesGranularity = exports.ReportPeriodKey = exports.CommerceType = exports.TaxDimensionType = exports.otherPaymentProviders = exports.fenaStripePaymentProviders = exports.fenaObPaymentProviders = void 0;
const payment_types_1 = require("../payment-types");
exports.fenaObPaymentProviders = [payment_types_1.PaymentProviders.FENA_OB,
    payment_types_1.PaymentProviders.FENA_OB_QR,
    payment_types_1.PaymentProviders.FENA_MOBILE,
    payment_types_1.PaymentProviders.FENA_MOBILE_TOUCH_TO_PAY,
    payment_types_1.PaymentProviders.FENA_CHECKOUT,
];
// if you create fena checkot . TO CHECK DOUBLE PAYMENT FLOW. to think if we can merge them in other payment methd or smth
exports.fenaStripePaymentProviders = [payment_types_1.PaymentProviders.FENA_STRIPE, payment_types_1.PaymentProviders.FENA_CARD_PAYMENTS];
exports.otherPaymentProviders = [payment_types_1.PaymentProviders.NONE, payment_types_1.PaymentProviders.OTHER];
var TaxDimensionType;
(function (TaxDimensionType) {
    TaxDimensionType["PRODUCT"] = "product";
    TaxDimensionType["SHIPPING"] = "shipping";
})(TaxDimensionType = exports.TaxDimensionType || (exports.TaxDimensionType = {}));
var CommerceType;
(function (CommerceType) {
    CommerceType["RETAIL"] = "retail";
    CommerceType["WHOLESALE"] = "wholesale";
    CommerceType["ALL"] = "all";
})(CommerceType = exports.CommerceType || (exports.CommerceType = {}));
var ReportPeriodKey;
(function (ReportPeriodKey) {
    ReportPeriodKey["THIS_WEEK"] = "this_week";
    ReportPeriodKey["THIS_MONTH"] = "this_month";
    ReportPeriodKey["THIS_YEAR"] = "this_year";
    ReportPeriodKey["LAST_WEEK"] = "last_week";
    ReportPeriodKey["LAST_MONTH"] = "last_month";
    ReportPeriodKey["LAST_YEAR"] = "last_year";
    ReportPeriodKey["ALL_TIME"] = "all_time";
    ReportPeriodKey["CUSTOM"] = "custom";
    // for comparisons with last week/month/year . a temporary workaround (or not , if  we won't go with V2 report structure )
    ReportPeriodKey["WEEK_BEFORE_LAST_WEEK"] = "week_before_last_week";
    ReportPeriodKey["MONTH_BEFORE_LAST_MONTH"] = "month_before_last_month";
    ReportPeriodKey["YEAR_BEFORE_LAST_YEAR"] = "year_before_last_year";
})(ReportPeriodKey = exports.ReportPeriodKey || (exports.ReportPeriodKey = {}));
/**
 * Time bucket granularity for period time-series.
 * Values align with MongoDB $dateTrunc unit.
 */
var TimeSeriesGranularity;
(function (TimeSeriesGranularity) {
    TimeSeriesGranularity["DAY"] = "day";
    TimeSeriesGranularity["WEEK"] = "week";
    TimeSeriesGranularity["MONTH"] = "month";
    TimeSeriesGranularity["YEAR"] = "year";
})(TimeSeriesGranularity = exports.TimeSeriesGranularity || (exports.TimeSeriesGranularity = {}));
